module.exports = __webpack_public_path__ + "img/estrellas.fc362596.png";